module.exports = __webpack_public_path__ + "img/chat-square-quote.c5fae3ec.svg";